/* 注意：name值一定不要相同，否则会出错 */
let routerList = [
  {
    path: "/index",
    name: "Home",
    meta: {
      title: "首页",
      isChild: false, //是否在导航栏上显示子级
      isOpen: false,
    },
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/details",
    name: "details",
    component: () => import("@/views/home/detail.vue"),
  },
  {
    path: "/moreDetail",
    name: "moreDetail",
    component: () => import("@/views/home/moreDetail.vue"),
  },
];
export default routerList;
